import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import * as React from "react";
import ReactSVG from "react-svg";
import { NavLink, SocialMediaIcon } from "..";
import { TypedSecondaryMenuQuery } from "./queries";
import { SOCIAL_MEDIA } from "../../core/config";
import arrowRightImg from "../../images/arrow-right.svg";
import "./scss/index.scss";

var Nav =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Nav, _React$PureComponent);

  function Nav() {
    _classCallCheck(this, Nav);

    return _possibleConstructorReturn(this, _getPrototypeOf(Nav).apply(this, arguments));
  }

  _createClass(Nav, [{
    key: "render",
    value: function render() {
      return React.createElement("footer", {
        className: "footer-nav"
      }, React.createElement("div", {
        className: "footer-nav-left"
      }, React.createElement("h4", {
        className: "footer-nav__section-header"
      }, "Stay In Touch"), React.createElement("div", {
        className: "footer-nav__section-content"
      }, React.createElement("p", null, "Receive email updates on products, launches and events."), React.createElement("p", null, "Unsubscribe anytime.")), React.createElement("div", {
        className: "footer-nav-input"
      }, React.createElement("div", {
        className: "input-container"
      }, React.createElement("input", {
        placeholder: "Your email"
      }), React.createElement(ReactSVG, {
        path: arrowRightImg,
        className: "arrow-right"
      }))), React.createElement("div", {
        className: "footer__favicons"
      }, SOCIAL_MEDIA.map(function (medium) {
        return React.createElement(SocialMediaIcon, {
          medium: medium,
          key: medium.ariaLabel
        });
      })), React.createElement("div", {
        className: "footer-nav-country"
      }, React.createElement("p", null, "New Zealand", React.createElement("span", null, " (Change)")))), React.createElement("div", {
        className: "footer-nav-right container"
      }, React.createElement(TypedSecondaryMenuQuery, null, function (_ref) {
        var data = _ref.data;
        return data.shop.navigation.secondary.items.map(function (item) {
          return React.createElement("div", {
            className: "footer-nav__section",
            key: item.id
          }, React.createElement("h4", {
            className: "footer-nav__section-header"
          }, React.createElement("span", null, item.name)), React.createElement("div", {
            className: "footer-nav__section-content"
          }, item.children.map(function (subItem) {
            return React.createElement("p", {
              key: subItem.id
            }, React.createElement(NavLink, {
              item: subItem
            }));
          })));
        });
      })));
    }
  }]);

  return Nav;
}(React.PureComponent);

export default Nav;